export const OPERATION = 'Operation';
//# sourceMappingURL=operation.js.map